import axios from 'axios'
import util from '../util'

export default class LicenseService {
  static async bulkCreateLicenses (organizationNumbers, eans, license) {
    const params = new URLSearchParams()
    organizationNumbers.forEach(organizationNumber => params.append('organizationNumber', organizationNumber))
    eans.forEach(ean => params.append('ean', ean))
    params.append("strict", true)

    license.description = util.emptyToNull(license.description)

    return axios
      .post(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/',
        license,
        {
          params: params
        }
      ).then(response => response)
  }

  static async getLicensesByEan (ean) {
    const params = new URLSearchParams()
    params.append("ean", ean)

    return axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/',
        {
          params: params
        }
      ).then(response => response.data)
  }

  static async deleteLicenseByLicenseIds (ids) {
    return axios
      .delete(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/' + ids)
  }

  static async setForcedOnLicenseUsage (userId, licenseId, forced) {
    return axios.patch(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/usages/force', null,
      {
        params: { userId, licenseId, forced }
      })
  }

  // Registers product access for the user, which creates a license usage row on the organization
  static async registerProductAccess (ean, userId, organizationNumber) {
    return axios.post(process.env.VUE_APP_INTERNAL_API_BASEURL + '/product/' + ean + '/access/' + userId + '/' + organizationNumber)
  }
}
